export default __webpack_public_path__ + "static/media/imgLoading.fdfbfc44.gif";